/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import { Classes } from "../";
export function isDarkTheme(element) {
    return element.closest("." + Classes.DARK) != null;
}



//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/dist/esm/common/utils/isDarkTheme.js
// module id = 443
// module chunks = 0